<template>
  <div>
    <div class="video-modal" :style="`height:${height}px`">
      <Player type="youtube" :id="videoId" />
    </div>
  </div>
</template>

<script>
import EventLog from "@/mixins/resourceBlocks/EventLog";
import Player from "@/components/common/player";
export default {
  name: "AboutIntro_Tutorials",
  mixins: [EventLog],
  components: {
    Player
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    videoId: {
      type: String,
      default: "3yUzCr7VVn0"
    },
    height: {
      type: Number,
      default: 300
    }
  },
  computed: {},
  methods: {
    handleVideoPlayed() {
      this.handleEventLog({
        name: "aboutIntro.tutorial.videoPlayed",
        payload: { videoId: this.videoId },
        level: "info"
      });
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.video-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .play-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
  .close-icon {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
.footer {
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;
}
</style>
